'use client'

import React from 'react'

import type { ChartsAxisContentProps } from '@mui/x-charts/ChartsTooltip'

import { useSrpContext } from '@/src/contexts'

import BestTimeToVisit, { WeatherTooltipContent } from './bestTimeToVisit'

const BestTimeToVisitWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const climate = sections?.climate
    if (!climate?.summary) return null

    const monthlyHighlights = climate.monthlyHighlights ?? []

    const chartDataset = monthlyHighlights.map(m => ({
        high: m.avgHighC,
        low: m.avgLowC,
        rainfall: m.rainfallMm,
        month: m.month,
    }))

    const allTemps = monthlyHighlights.flatMap(m => [m.avgHighC, m.avgLowC])
    const tempMin = allTemps.length ? Math.floor(Math.min(...allTemps)) - 3 : 0
    const tempMax = allTemps.length ? Math.ceil(Math.max(...allTemps)) + 3 : 40

    const TooltipSlot: React.ElementType<ChartsAxisContentProps> = React.useMemo(() => {
        const data = monthlyHighlights
        const Slot: React.FC<ChartsAxisContentProps> = ({ dataIndex }) => {
            if (dataIndex == null || dataIndex < 0 || !data[dataIndex]) return null
            const m = data[dataIndex]
            return (
                <WeatherTooltipContent
                    month={m.month}
                    high={m.avgHighC}
                    low={m.avgLowC}
                    rain={m.rainfallMm}
                    condition={m.condition}
                    note={m.note}
                />
            )
        }
        return Slot
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthlyHighlights.length])

    return (
        <BestTimeToVisit
            title={climate.title}
            summary={climate.summary}
            bestMonths={climate.bestMonths ?? []}
            chartDataset={chartDataset}
            tempMin={tempMin}
            tempMax={tempMax}
            TooltipSlot={TooltipSlot}
        />
    )
}

export default BestTimeToVisitWrapper
